export default function Areas(stateWatch) {
  var data = [];
  if (stateWatch === "ak") {
    data = require("./data/ak.json");
  } else if (stateWatch === "al") {
    data = require("./data/al.json");
  } else if (stateWatch === "ar") {
    data = require("./data/ar.json");
  } else if (stateWatch === "az") {
    data = require("./data/az.json");
  } else if (stateWatch === "ca") {
    data = require("./data/ca.json");
  } else if (stateWatch === "co") {
    data = require("./data/co.json");
  } else if (stateWatch === "ct") {
    data = require("./data/ct.json");
  } else if (stateWatch === "dc") {
    data = require("./data/dc.json");
  } else if (stateWatch === "de") {
    data = require("./data/de.json");
  } else if (stateWatch === "fl") {
    data = require("./data/fl.json");
  } else if (stateWatch === "ga") {
    data = require("./data/ga.json");
  } else if (stateWatch === "hi") {
    data = require("./data/hi.json");
  } else if (stateWatch === "ia") {
    data = require("./data/ia.json");
  } else if (stateWatch === "id") {
    data = require("./data/id.json");
  } else if (stateWatch === "il") {
    data = require("./data/il.json");
  } else if (stateWatch === "in") {
    data = require("./data/in.json");
  } else if (stateWatch === "ks") {
    data = require("./data/ks.json");
  } else if (stateWatch === "ky") {
    data = require("./data/ky.json");
  } else if (stateWatch === "la") {
    data = require("./data/la.json");
  } else if (stateWatch === "ma") {
    data = require("./data/ma.json");
  } else if (stateWatch === "md") {
    data = require("./data/md.json");
  } else if (stateWatch === "me") {
    data = require("./data/me.json");
  } else if (stateWatch === "mi") {
    data = require("./data/mi.json");
  } else if (stateWatch === "mn") {
    data = require("./data/mn.json");
  } else if (stateWatch === "mo") {
    data = require("./data/mo.json");
  } else if (stateWatch === "ms") {
    data = require("./data/ms.json");
  } else if (stateWatch === "mt") {
    data = require("./data/mt.json");
  } else if (stateWatch === "nc") {
    data = require("./data/nc.json");
  } else if (stateWatch === "nd") {
    data = require("./data/nd.json");
  } else if (stateWatch === "ne") {
    data = require("./data/ne.json");
  } else if (stateWatch === "nh") {
    data = require("./data/nh.json");
  } else if (stateWatch === "nj") {
    data = require("./data/nj.json");
  } else if (stateWatch === "nm") {
    data = require("./data/nm.json");
  } else if (stateWatch === "nv") {
    data = require("./data/nv.json");
  } else if (stateWatch === "ny") {
    data = require("./data/ny.json");
  } else if (stateWatch === "oh") {
    data = require("./data/oh.json");
  } else if (stateWatch === "ok") {
    data = require("./data/ok.json");
  } else if (stateWatch === "or") {
    data = require("./data/or.json");
  } else if (stateWatch === "pa") {
    data = require("./data/pa.json");
  } else if (stateWatch === "ri") {
    data = require("./data/ri.json");
  } else if (stateWatch === "sc") {
    data = require("./data/sc.json");
  } else if (stateWatch === "sd") {
    data = require("./data/sd.json");
  } else if (stateWatch === "tn") {
    data = require("./data/tn.json");
  } else if (stateWatch === "tx") {
    data = require("./data/tx.json");
  } else if (stateWatch === "ut") {
    data = require("./data/ut.json");
  } else if (stateWatch === "va") {
    data = require("./data/va.json");
  } else if (stateWatch === "vt") {
    data = require("./data/vt.json");
  } else if (stateWatch === "wa") {
    data = require("./data/wa.json");
  } else if (stateWatch === "wi") {
    data = require("./data/wi.json");
  } else if (stateWatch === "wv") {
    data = require("./data/wv.json");
  } else if (stateWatch === "wy") {
    data = require("./data/wy.json");
  } else {
    data = require("./data/md.json");
  }

  let selectOptions = [];
  let v = data;

  if (stateWatch) {
    for (let i = 0; i < v.length; i++) {
      selectOptions.push(v[i]);
    }
  } else {
    selectOptions = [];
  }
  return selectOptions;
}
